import Phaser from 'phaser';
import './style.css';
import { GameScene } from './game/GameScene';
import { Sfx } from './game/Sfx';

const startPanel = document.querySelector<HTMLDivElement>('#start-panel')!;
const joinButton = document.querySelector<HTMLButtonElement>('#join-button')!;
const callsignInput = document.querySelector<HTMLInputElement>('#callsign')!;
const hud = document.querySelector<HTMLElement>('#hud')!;
const feed = document.querySelector<HTMLElement>('#event-feed')!;
const sfx = new Sfx();

function startGame(): void {
  const name = callsignInput.value.trim().slice(0, 16) || '생존자';
  sfx.unlock();
  startPanel.classList.remove('visible');
  hud.classList.remove('hidden');
  feed.classList.remove('hidden');

  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'game-container',
    width: 1280,
    height: 720,
    backgroundColor: '#0a0d12',
    physics: {
      default: 'arcade',
      arcade: { debug: false },
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 1280,
      height: 720,
    },
    render: {
      antialias: true,
      pixelArt: false,
      roundPixels: false,
    },
    scene: [],
  });

  game.scene.add('GameScene', new GameScene(name, sfx), true);
}

joinButton.addEventListener('click', startGame, { once: true });
callsignInput.addEventListener('keydown', (event) => {
  if (event.key === 'Enter') joinButton.click();
});

callsignInput.focus();
